var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { QboTemplate, template } from "@quandis/qbo4.configuration";
import { formatDate, formatMoney, formatPercentage, qboui, QboFetchMixin, timeRemaining } from '@quandis/qbo4.ui';
import { JSONPath } from 'jsonpath-plus';
export class QboLoan extends QboFetchMixin(QboTemplate) {
    constructor() {
        super(...arguments);
        this.jsonData = {};
        this.appraisalTemplate = 'Appraisal';
        this.show = true;
        this.type = 'search';
        this.imagePath = window.qbo4['imagePath'] ?? '/ui/images/qbo-icons.svg';
        this.tabLoaded = false;
    }
    static { this.styles = [
        qboui
    ]; }
    updated(changedProperties) {
        super.updated(changedProperties);
        this.shadowRoot?.querySelectorAll('span').forEach(span => {
            if (span instanceof HTMLSpanElement) {
                if (span.innerText == '')
                    span.classList.add('emptyValue');
                else if (span.classList.contains('emptyValue'))
                    span.classList.remove('emptyValue');
            }
        });
        if (this.jsonData?.Root?.LoanItem?.LoanID && !this.tabLoaded) {
            this.tabLoaded = true;
            const loanId = this.jsonData?.Root?.LoanItem?.LoanID;
            let count, label;
            if (this.jsonData?.Root?.ProcessItem.length)
                count = this.jsonData?.Root?.ProcessItem.length;
            else if (this.jsonData?.Root?.ProcessItem)
                count = 1;
            else
                count = 0;
            label = `Processes` + (count > 0 ? ` (${count})` : ``);
            this.dispatchEvent(new CustomEvent('qbo-loan-add', {
                detail: {
                    title: label,
                    render: html `<qbo-process type="searchTab" .fetchOnLoad=${false} .jsonData=${this.jsonData?.Root?.ProcessItem} data-object="Loan" data-objectid="${loanId}"></qbo-process>`
                },
                bubbles: true,
                composed: true
            }));
            if (this.jsonData?.Root?.DecisionItem.length)
                count = this.jsonData?.Root?.DecisionItem.length;
            else if (this.jsonData?.Root?.DecisionItem)
                count = 1;
            else
                count = 0;
            label = `Workflows` + (count > 0 ? ` (${count})` : ``);
            this.dispatchEvent(new CustomEvent('qbo-loan-add', {
                detail: {
                    title: label,
                    render: html `<qbo-decision type="searchTab" .fetchOnLoad=${false} .jsonData=${this.jsonData?.Root?.DecisionItem} data-object="Loan" data-objectid="${loanId}"></qbo-decision>`,
                    focus: false
                },
                bubbles: true,
                composed: true
            }));
            if (this.jsonData?.Root?.ImportFormItem.length)
                count = this.jsonData?.Root?.ImportFormItem.length;
            else if (this.jsonData?.Root?.ImportFormItem)
                count = 1;
            else
                count = 0;
            label = `Tasks` + (count > 0 ? ` (${count})` : ``);
            this.dispatchEvent(new CustomEvent('qbo-loan-add', {
                detail: {
                    title: label,
                    render: html `<qbo-importform type="searchTab" .fetchOnLoad=${false} .jsonData=${this.jsonData?.Root?.ImportFormItem} data-object="Loan" data-objectid="${loanId}"></qbo-importform>`,
                    focus: false
                },
                bubbles: true,
                composed: true
            }));
        }
    }
    borrower(component) {
        let borrower1;
        let borrower2;
        if (component.jsonData?.BorrowerItem.length) {
            const borrowers = JSONPath({ path: `$..BorrowerItem[?(@.Sequence=='1' || @.Sequence=='2' || !@.Sequence)]`, json: component.jsonData });
            borrower1 = borrowers.find((element) => element.Sequence == '1');
            if (!borrower1)
                borrower1 = borrowers.find((element) => !element.Sequence);
            borrower2 = borrowers.find((element) => element.Sequence == '2');
            if (!borrower2)
                borrower2 = borrowers.findLast((element) => !element.Sequence);
        }
        else {
            borrower1 = component.jsonData?.BorrowerItem;
        }
        return html `<slot class=${component.show ? '' : 'collapse'}>
<h3 class="title">
    <button type="button" class="expandcollapse" @click="${(e) => component.show = !component.show}">
        <svg>
            <use href="${component.imagePath}#${component.show ? 'dash' : 'plus'}">
        </svg>
    </button>
    Borrower Information
</h3>
<div class="qbo-row">
    <div class="qbo-col qbo-col-noborder">
        <div class="qbo-form">
            <label>Borrower</label>
            <span>${borrower1?.Borrower}</span>
            <label>Phone Number</label>
            <span>${borrower1?.Phone}</span>
            <label>Email Address</label>
            <span>${borrower1?.Email}</span>
        </div>
    </div>
    <div class="qbo-col qbo-col-noborder">
        <div class="qbo-form">
            <label>Co-Borrower</label>
            <span>${borrower2?.Borrower}</span>
            <label>Phone Number</label>
            <span>${borrower2?.Phone}</span>
            <label>Email Address</label>
            <span>${borrower2?.Email}</span>
        </div>
    </div>
</div>
        </slot>`;
    }
    property(component) {
        const valuations = component.jsonData?.ValuationItem;
        let valuation;
        if (valuations?.length > 0) {
            valuation = JSONPath({ path: `$..ValuationItem[?(@.ProcessTemplate=='${component.appraisalTemplate}')]`, json: component.jsonData });
            valuation = valuation.length ? valuation[valuation.length - 1] : valuation;
        }
        else if (valuations && !valuations?.length) {
            valuation = valuations;
        }
        return html `<slot class=${component.show ? '' : 'collapse'}>${component.jsonData ? html `
<h3 class="title">
    <button type="button" class="expandcollapse" @click="${(e) => component.show = !component.show}">
        <svg>
            <use href="${component.imagePath}#${component.show ? 'dash' : 'plus'}">
        </svg>
    </button>
    Property Information
</h3>
<div class="qbo-row">
    <div class="qbo-col qbo-col-noborder">
        <div class="qbo-form">
            <label>Property Address</label>
            <span>${component.jsonData.PropertyItem?.Address}, ${component.jsonData.PropertyItem?.City}, ${component.jsonData.PropertyItem?.State} ${component.jsonData.PropertyItem?.PostalCode}</span>
            <label>Property Type</label>
            <span>${component.jsonData.PropertyItem?.PropertyType}</span>
            <label>Property Value (Appraised)</label>
            <span>${formatMoney(valuation?.ValueAsIs)}</span>
            <label>Appraisal Date</label>
            <span>${formatDate(valuation?.CompletedDate)}</span>
        </div>
    </div>
</div>
        ` : html `
<div class="qbo-row">
    <div class="qbo-col qbo-col-noborder">
        <div class="qbo-form">
            <label>No data available</label>
        </div>
    </div>
</div>
        `}</slot>`;
    }
    propertyDetails(component) {
        const insurancepolicies = component.jsonData?.InsurancePolicyItem;
        let insurancepolicy;
        if (insurancepolicies?.length > 0) {
            insurancepolicy = JSONPath({ path: `$..InsurancePolicyItem`, json: component.jsonData });
            insurancepolicy = insurancepolicy.length ? insurancepolicy[insurancepolicy.length - 1] : insurancepolicy;
        }
        else if (insurancepolicies && !insurancepolicies?.length) {
            insurancepolicy = insurancepolicies;
        }
        return html `<slot class=${component.show ? '' : 'collapse'}>${component.jsonData ? html `
<h3 class="title">
    <button type="button" class="expandcollapse" @click="${(e) => component.show = !component.show}">
        <svg>
            <use href="${component.imagePath}#${component.show ? 'dash' : 'plus'}">
        </svg>
    </button>
    Property Details
</h3>
<div class="qbo-row">
    <div class="qbo-col qbo-col-noborder">
        <div class="qbo-form">
            <h4 class="title">Property Taxes</h4>
            <label>Annual Property Tax Amount</label>
            <span></span>
            <label>Next Property Tax Due Date</label>
            <span></span>
            <label>Tax Payment Status</label>
            <span></span>
        </div>
    </div>
    <div class="qbo-col qbo-col-noborder">
        <div class="qbo-form">
            <h4 class="title">Homeowner's Insurance</h4>
            <label>Insurance Provider</label>
            <span>${insurancepolicy?.Insurer}</span>
            <label>Insurance Policy Number</label>
            <span>${insurancepolicy?.InsurancePolicy}</span>
            <label>Annual Premium</label>
            <span>${formatMoney(insurancepolicy?.Premium)}</span>
            <label>Next Premium Due Date</label>
            <span>${formatDate(insurancepolicy?.DateDue)}</span>
            <label>Insurance Coverage Amount</label>
            <span>${formatMoney(insurancepolicy?.Coverage)}</span>
        </div>
    </div>
    <div class="qbo-col qbo-col-noborder">
        <div class="qbo-form">
            <h4 class="title">HOA Fees</h4>
            <label>Monthly HOA Fee</label>
            <span>${formatMoney(component.jsonData.PropertyItem?.HOAPaymentAmount)}</span>
            <label>HOA Next Payment Due Date</label>
            <span></span>
        </div>
    </div>
</div>
        ` : html `
<div class="qbo-row">
    <div class="qbo-col qbo-col-noborder">
        <div class="qbo-form">
            <label>No data available</label>
        </div>
    </div>
</div>
        `}</slot>`;
    }
    select(component) {
        component.jsonData ??= component.jsonData?.Root?.LoanItem;
        return html `<slot class=${component.show ? '' : 'collapse'}>${component.jsonData ? html `
<h3 class="title">
    <button type="button" class="expandcollapse" @click="${(e) => component.show = !component.show}">
        <svg>
            <use href="${component.imagePath}#${component.show ? 'dash' : 'plus'}">
        </svg>
    </button>
    Loan Information
</h3>
<div class="qbo-row">
    <div class="qbo-col qbo-col-noborder">
        <div class="qbo-form">
            <label>Loan Number</label>
            <span>${component.jsonData.Loan}</span>
            <label>Loan Status</label>
            <span>${component.jsonData.Status}</span>
            <label>Loan Type</label>
            <span>${component.jsonData.LoanType}</span>
            <label>Loan Origination Date</label>
            <span></span>
            <label>Servicing Contact</label>
            <span>${component.jsonData.Servicer}</span>
        </div>
    </div>
    <div class="qbo-col qbo-col-noborder">
        <div class="qbo-form">
            <label>Payment Due Date</label>
            <span>${formatDate(component.jsonData.NextPaymentDue)}</span>
            <label>Interest Rate</label>
            <span>${formatPercentage(component.jsonData.InterestRateCurrent, 3)}</span>
            <label>Escrow Account</label>
            <span></span>
            <label>Maturity Date</label>
            <span>${formatDate(component.jsonData.LoanMaturityDate)}</span>
            <label>Current Payment Plan</label>
            <span></span>
        </div>
    </div>
    <div class="qbo-col qbo-col-noborder">
        <div class="qbo-form">
            <label>Next Payment Amount</label>
            <span>${formatMoney(component.jsonData.PaymentAmount)}</span>
            <label>Late Fees Due</label>
            <span>${formatMoney(component.jsonData.LateChargeBalance)}</span>
            <label>Amortization Type</label>
            <span>${component.jsonData.AmortizationType}</span>
            <label>Remaining Loan Term</label>
            <span>${timeRemaining(component.jsonData.LoanMaturityDate)}</span>
            <label>Escrow Analysis</label>
            <span></span>
        </div>
    </div>
    <div class="qbo-col qbo-col-noborder">
        <div class="qbo-form">
            <label>Loan Amount (Current Balance)</label>
            <span>${formatMoney(component.jsonData.UPBAmount)}</span>
            <label>Loan Amount (Original)</label>
            <span>${formatMoney(component.jsonData.OriginalBalance)}</span>
            <label>Last Payment Date</label>
            <span>${formatDate(component.jsonData.LastPaymentReceived)}</span>
            <label>Last Payment Amount</label>
            <span></span>
            <label>Delinquency History</label>
            <span></span>
        </div>
    </div>
</div>
        ` : html `
<div class="qbo-row">
    <div class="qbo-col qbo-col-noborder">
        <div class="qbo-form">
            <label>No data available</label>
        </div>
    </div>
</div>
        `}</slot>`;
    }
    status(component) {
        component.jsonData ??= component.jsonData?.Root;
        let dueDate = component.jsonData?.LoanItem?.NextPaymentDue;
        let dueDateText = 'Current';
        let dueDateClass = 'green';
        if (dueDate && dueDate.trim() != '') {
            const ms = new Date().getTime() - new Date(dueDate).getTime();
            const days = ms / (1000 * 60 * 60 * 24);
            if (days > 30 && days < 60) {
                dueDateText = '30+ Delinquent';
                dueDateClass = 'yellow';
            }
            else if (days > 59 && days < 90) {
                dueDateText = '60-90 Delinquent';
                dueDateClass = 'yellow';
            }
            else if (days > 89) {
                dueDateText = '90+ Delinquent';
                dueDateClass = 'red';
            }
        }
        let delay = false;
        if (component.jsonData?.DecisionDelayItem?.length)
            delay = JSONPath({ path: `$..DecisionDelayItem[?(!@.AdtualCompletion)]`, json: component.jsonData })[0];
        else if (component.jsonData?.DecisionDelayItem && !component.jsonData?.DecisionDelayItem?.ActualCompletion)
            delay = true;
        let FcText = 'Not Active';
        let FcClass = 'green';
        if (component.jsonData?.ForeclosureItem?.length) {
            const foreclosures = JSONPath({ path: `$..ForeclosureItem[?(!@.DateClosed)]`, json: component.jsonData });
            const foreclosure = foreclosures.find((element) => element.Status.toLowerCase().contains('hold'));
            if (foreclosure || delay) {
                FcText = 'On Hold';
                FcClass = 'yellow';
            }
            else {
                FcText = 'Active';
                FcClass = 'red';
            }
        }
        else {
            const foreclosure = component.jsonData?.ForeclosureItem;
            if (foreclosure && !foreclosure.DateClosed && (foreclosure.Status?.toLowerCase().contains('hold') || delay)) {
                FcText = 'On Hold';
                FcClass = 'yellow';
            }
            else if (foreclosure && !foreclosure.DateClosed) {
                FcText = 'Active';
                FcClass = 'red';
            }
        }
        let BkText = 'Not Active';
        let BkClass = 'green';
        if (component.jsonData?.BankruptcyItem?.length) {
            let bankruptcy = component.jsonData?.BankruptcyItem.findLast((element) => !element.DismissedDate && !element.DischargedDate && !element.DateClosed);
            if (bankruptcy) {
                BkText = 'Active';
                BkClass = 'red';
            }
            else {
                bankruptcy = component.jsonData?.BankruptcyItem.findLast((element) => !element.DismissedDate);
                if (bankruptcy) {
                    BkText = 'Dismissed';
                    BkClass = 'yellow';
                }
                else {
                    bankruptcy = component.jsonData?.BankruptcyItem.findLast((element) => !element.DischargedDate);
                    if (bankruptcy) {
                        BkText = `Discharged - ${bankruptcy.Chapter}`;
                        BkClass = 'yellow';
                    }
                }
            }
        }
        else if (component.jsonData?.BankruptcyItem) {
            const bankruptcy = component.jsonData?.BankruptcyItem;
            if (!bankruptcy.DismissedDate && !bankruptcy.DischargedDate && !bankruptcy.DateClosed) {
                BkText = 'Active';
                BkClass = 'red';
            }
            else if (bankruptcy.DismissedDate) {
                BkText = 'Dismissed';
                BkClass = 'yellow';
            }
            else if (bankruptcy.DischargedDate) {
                BkText = `Discharged - ${bankruptcy.Chapter}`;
                BkClass = 'yellow';
            }
        }
        return html `<slot class=${component.show ? '' : 'collapse'}>${component.jsonData ? html `
<div class="qbo-row">
    <div class="qbo-col qbo-col-noborder">
        <div class="qbo-form qbo-form-status">
            <label>Delinquency Warning</label>
            <span class="${dueDateClass}">${dueDateText}</span>
        </div>
    </div>
    <div class="qbo-col qbo-col-noborder">
        <div class="qbo-form qbo-form-status">
            <label>Collection Status</label>
            <span class="green">N/A</span>
        </div>
    </div>
    <div class="qbo-col qbo-col-noborder">
        <div class="qbo-form qbo-form-status">
            <label>Loss Mitigation Status</label>
            <span class="green">N/A</span>
        </div>
    </div>
    <div class="qbo-col qbo-col-noborder">
        <div class="qbo-form qbo-form-status">
            <label>Foreclosure Status</label>
            <span class="${FcClass}">${FcText}</span>
        </div>
    </div>
    <div class="qbo-col qbo-col-noborder">
        <div class="qbo-form qbo-form-status">
            <label>Bankruptcy Status</label>
            <span class="${BkClass}">${BkText}</span>
        </div>
    </div>
</div>
        ` : html `
<div class="qbo-row">
    <div class="qbo-col qbo-col-noborder">
        <div class="qbo-form qbo-form-status">
            <label>No data available</label>
        </div>
    </div>
</div>
        `}</slot>`;
    }
    summary(component) {
        return html `
<div class="qbo-row-container">
    <div class="qbo-row">
        <div class="qbo-card">
            <qbo-loan type="status" .jsonData=${component.jsonData?.Root}></qbo-loan>
        </div>
    </div>
    <div class="qbo-row">
        <div class="qbo-card">
            <qbo-loan type="select" .jsonData=${component.jsonData?.Root?.LoanItem}></qbo-loan>
        </div>
    </div>
    <div class="qbo-row">
        <div class="qbo-card">
            <qbo-loan type="property" .jsonData=${component.jsonData?.Root}></qbo-loan>
        </div>
        <div class="qbo-card">
            <qbo-loan type="borrower" .jsonData=${component.jsonData?.Root}></qbo-loan>
        </div>
    </div>
    <div class="qbo-row">
        <div class="qbo-card">
            <qbo-loan type="property-details" .show=${false} .jsonData=${component.jsonData?.Root}></qbo-loan>
        </div>
    </div>
    <div class="qbo-row">
        <div class="qbo-card">
            <qbo-activity .show=${false} .jsonData=${component.jsonData?.Root}></qbo-activity>
        </div>
    </div>
    <div class="qbo-row">
        <div class="qbo-card">
            <qbo-document .type=${'searchSimple'} .showInline=${true} .fetchOnLoad=${false} .show=${false} .jsonData=${component.jsonData?.Root?.AttachmentItem} data-objectid="${component.jsonData?.Root?.LoanItem?.LoanID}" data-object="Loan"></qbo-document>
        </div>
    </div>
    <div class="qbo-row">
        <div class="qbo-card">
            <qbo-message .fetchOnLoad=${false} .show=${false} .jsonData=${component.jsonData?.Root?.MessageItem} data-objectid="${component.jsonData?.Root?.LoanItem?.LoanID}" data-object="Loan"></qbo-message>
        </div>
    </div>
    <div class="qbo-row">
        <div class="qbo-card">
            <qbo-loan type="workflow-details" .show=${false}></qbo-loan>
        </div>
    </div>
</div>
    `;
    }
    workflowDetails(component) {
        return html `<slot class=${component.show ? '' : 'collapse'}>
    <h3 class="title">
        <button type="button" class="expandcollapse" @click="${(e) => component.show = !component.show}">
            <svg>
                <use href="${component.imagePath}#${component.show ? 'dash' : 'plus'}">
            </svg>
        </button>
        Work Center
    </h3>
    <div class="qbo-row">
        <div class="qbo-col qbo-col-noborder">
            <qbo-tabs listener="qbo-loan-add"></qbo-tabs>
        </div>
    </div>
</slot>`;
    }
}
__decorate([
    property({ type: Object }),
    __metadata("design:type", Object)
], QboLoan.prototype, "jsonData", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboLoan.prototype, "appraisalTemplate", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboLoan.prototype, "show", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboLoan.prototype, "type", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboLoan.prototype, "imagePath", void 0);
__decorate([
    template('borrower'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [QboLoan]),
    __metadata("design:returntype", void 0)
], QboLoan.prototype, "borrower", null);
__decorate([
    template('property'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [QboLoan]),
    __metadata("design:returntype", void 0)
], QboLoan.prototype, "property", null);
__decorate([
    template('property-details'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [QboLoan]),
    __metadata("design:returntype", void 0)
], QboLoan.prototype, "propertyDetails", null);
__decorate([
    template('select'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [QboLoan]),
    __metadata("design:returntype", void 0)
], QboLoan.prototype, "select", null);
__decorate([
    template('status'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [QboLoan]),
    __metadata("design:returntype", void 0)
], QboLoan.prototype, "status", null);
__decorate([
    template('summary'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [QboLoan]),
    __metadata("design:returntype", void 0)
], QboLoan.prototype, "summary", null);
__decorate([
    template('workflow-details'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [QboLoan]),
    __metadata("design:returntype", void 0)
], QboLoan.prototype, "workflowDetails", null);
if (!customElements.get('qbo-loan'))
    customElements.define('qbo-loan', QboLoan);
